import { render, staticRenderFns } from "./single-table.vue?vue&type=template&id=b8297e68&scoped=true&"
import script from "./single-table.vue?vue&type=script&lang=js&"
export * from "./single-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8297e68",
  null
  
)

export default component.exports